<h2 mat-dialog-title class="mb-1 fs-3">Jelszó megváltoztatása</h2>
<button type="button" mat-icon-button (click)="onCancel()" class="close-btn">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
    <!-- Current Password -->
    <div class="mb-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Jelenlegi jelszó</mat-label>
        <input
          matInput
          [type]="hideCurrentPassword() ? 'password' : 'text'"
          formControlName="currentPassword"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideCurrentPassword.set(!hideCurrentPassword())"
          [attr.aria-label]="'Jelszó ' + (hideCurrentPassword() ? 'megjelenítés' : 'elrejtés')"
          [attr.aria-pressed]="!hideCurrentPassword()"
        >
          <mat-icon>{{ hideCurrentPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <!-- New Password -->
    <div class="">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Új jelszó</mat-label>
        <input
          matInput
          [type]="hideNewPassword() ? 'password' : 'text'"
          formControlName="newPassword"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideNewPassword.set(!hideNewPassword())"
          [attr.aria-label]="'Jelszó ' + (hideNewPassword() ? 'megjelenítés' : 'elrejtés')"
          [attr.aria-pressed]="!hideNewPassword()"
        >
          <mat-icon>{{ hideNewPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <!-- Password Requirements -->
    <div class="mb-5">
      <div class="password-requirements">
        <div class="requirement" [class.valid]="passwordRequirements().minLength">
          <mat-icon class="requirement-icon">{{
            passwordRequirements().minLength ? 'check' : 'close'
          }}</mat-icon>
          <span class="requirement-text">Legalább 8 karakter hosszúság kötelező!</span>
        </div>
        <div class="requirement" [class.valid]="passwordRequirements().hasUpperCase">
          <mat-icon class="requirement-icon">{{
            passwordRequirements().hasUpperCase ? 'check' : 'close'
          }}</mat-icon>
          <span class="requirement-text">Legalább 1 nagybetű használata kötelező!</span>
        </div>
        <div class="requirement" [class.valid]="passwordRequirements().hasLowerCase">
          <mat-icon class="requirement-icon">{{
            passwordRequirements().hasLowerCase ? 'check' : 'close'
          }}</mat-icon>
          <span class="requirement-text">Legalább 1 kisbetű használata kötelező!</span>
        </div>
        <div class="requirement" [class.valid]="passwordRequirements().hasNumber">
          <mat-icon class="requirement-icon">{{
            passwordRequirements().hasNumber ? 'check' : 'close'
          }}</mat-icon>
          <span class="requirement-text">Legalább 1 szám használata kötelező!</span>
        </div>
        <div class="requirement" [class.valid]="passwordRequirements().hasSpecialChar">
          <mat-icon class="requirement-icon">{{
            passwordRequirements().hasSpecialChar ? 'check' : 'close'
          }}</mat-icon>
          <span class="requirement-text">Legalább 1 speciális karakter használata kötelező!</span>
        </div>
      </div>
    </div>

    <!-- Confirm Password -->
    <div class="mb-1">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Új jelszó megerősítése</mat-label>
        <input
          matInput
          [type]="hideConfirmPassword() ? 'password' : 'text'"
          formControlName="confirmPassword"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideConfirmPassword.set(!hideConfirmPassword())"
          [attr.aria-label]="'Jelszó ' + (hideConfirmPassword() ? 'megjelenítés' : 'elrejtés')"
          [attr.aria-pressed]="!hideConfirmPassword()"
        >
          <mat-icon>{{ hideConfirmPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <!-- Password Match Validation -->
    @if (passwordForm.get('confirmPassword')?.value) {
    <div class="mb-2">
      <div
        class="password-match"
        [class.valid]="passwordsMatch()"
        [class.invalid]="!passwordsMatch()"
      >
        <mat-icon class="match-icon">{{ passwordsMatch() ? 'check' : 'close' }}</mat-icon>
        <span class="match-text">{{
          passwordsMatch() ? 'Jelszavak megegyeznek' : 'Jelszavak nem egyeznek'
        }}</span>
      </div>
    </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" (click)="onCancel()" class="btn btn-outline-primary">Mégse</button>
  <button
    type="submit"
    (click)="onSubmit()"
    [disabled]="!passwordForm.valid || isLoading()"
    class="btn btn-primary"
  >
    @if (isLoading()) {
      <mat-spinner diameter="20" class="me-2" style="display: inline-block;"></mat-spinner>
    }
    {{ isLoading() ? 'Mentés...' : 'Jelszó módosítása' }}
  </button>
</mat-dialog-actions>
